/**
 * InputNumber
 * input[type=number] 형식으로 수량 선택
 */
export default class InputNumber {
  /**
   * 외부 호출에 의해 객체에 필요한 값을 설정하고 input[type=number] 를 설정
   * @param {object} htParams
   *  {{
   *      {object} targetEl 값을 표시/저장할 대상 엘리먼트
   *      {number} nCount 현재 선택된 수량
   *      {number} nBuyLimitMin 선택할 수 있는 최소 수량
   *      {number} nBuyLimitMax 선택할 수 있는 최대 수량
   *      {function} callBackFn 값이 선택되었을 때 실행할 함수 (생략 가능)
   *      {function} onOverflowFn 값이 오버플로우되었을 때 (구매가능 최대수량을 넘어서는 숫자를 입력했을 때) 실행할 함수 (생략 가능)
   *  }}
   */
  open = htParams => {
    this.nBuyLimitMin = parseInt(htParams.nBuyLimitMin, 10);
    this.nBuyLimitMax = parseInt(htParams.nBuyLimitMax, 10);
    if (htParams.targetEl) {
      this.targetEl = htParams.targetEl;
    } else {
      this.targetEl = null;
    }

    if (htParams.callBackFn) {
      this.callBackFn = htParams.callBackFn;
    } else {
      this.callBackFn = null;
    }

    if (htParams.onOverflowFn) {
      this.onOverflowFn = htParams.onOverflowFn;
    } else {
      this.onOverflowFn = null;
    }

    this.renderInput(htParams);
  };

  renderInput = htParams => {
    this.targetEl.hide();
    this.targetEl.after(`<input type="number" value="${htParams.nCount}">`);
    this.setEvent();
  };

  setEvent = () => {
    this.targetEl
      .siblings('input')
      .on('change keydown keypress keyup mousedown click mouseup', e => {
        this.onChangeInputNum(e);
      });
    this.targetEl.siblings('input').on('blur', e => {
      this.onBlurInputNum(e);
    });
  };

  clearEvent = () => {
    this.targetEl
      .siblings('input')
      .off('change keydown keypress keyup mousedown click mouseup');
    this.targetEl.siblings('input').off('blur');
  };

  onChangeInputNum = e => {
    let nVal = parseInt($(e.currentTarget).val(), 10);
    if (!nVal) {
      return;
    }
    if (nVal < this.nBuyLimitMin) {
      nVal = this.nBuyLimitMin;
      $(e.currentTarget).val(nVal);
    }
    if (nVal > this.nBuyLimitMax) {
      nVal = this.nBuyLimitMax;
      $(e.currentTarget).val(nVal);
      if (typeof this.onOverflowFn === 'function') {
        this.onOverflowFn(this.targetEl);
      }
    }
    if (typeof this.callBackFn === 'function')
      this.callBackFn(this.targetEl, nVal);
  };

  onBlurInputNum = e => {
    this.clearEvent();
    $(e.currentTarget)
      .siblings('strong')
      .show();
    $(e.currentTarget).remove();
  };
}
